export default __webpack_public_path__ + "static/media/gold-1.66ae3a1b.png";